









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteInvoiceType, QueryInvoiceTypeList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { StatusFormat } from '@/utils/tyepconvert'
import { Message, MessageBox } from 'element-ui'
import EditInvoiceTypeDialog from './EditInvoiceTypeDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    EditInvoiceTypeDialog,
  },
})
export default class InvoiceTypeList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '发票类型名称', param: 'typeName' },
    { title: '类型代码', param: 'typeCode', type: 'select', selectData: [
      { label: '无需发票', value: 0 },
      { label: '普通发票', value: 1 },
      { label: '增值税专用发票', value: 2 },
      { label: '增值税普通发票', value: 3 },
    ]},
    { title: '状态', param: 'status', type: 'select', selectData: [
      { label: '禁用', value: 0 },
      { label: '启用', value: 1 },
    ]},
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '创建发票类型', type: 'primary', click: this.openCreate }
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index', width: 60 },
    { title: '发票类型名称', param: 'typeName', width: 150 },
    { title: '状态', param: 'status', width: 80, formatter: StatusFormat},
    { title: '备注', param: 'remark', overflow: true },
    { title: '创建时间', param: 'createTime', formatter: DateFormat, width: 160 },
    {
      title: '操作',
      width: 150,
      operation: [
        { title: '编辑', click: this.openEdit },
        { title: '删除', click: this.delete },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  private openCreate() {
    const d = this.$refs.EditInvoiceTypeDialog as EditInvoiceTypeDialog
    d.open({}, false)
  }

  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const result = await DeleteInvoiceType({ id: data.id })
      if (result) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  public openEdit(data: any) {
    const d = this.$refs.EditInvoiceTypeDialog as EditInvoiceTypeDialog
    d.open(data, true)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 10)
    const result = await QueryInvoiceTypeList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
